// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3GkEJ","form":"styles_form__2xxvD"};